var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrapper',[_c('loading-screen',{attrs:{"isActive":_vm.isLoading}},[_c('main',{staticClass:"main-content-wrapper"},[_c('employee-log',{attrs:{"logData":_vm.employeeLog}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('employee-form',{attrs:{"employee":_vm.employeeData},on:{"submit":_vm.handleSubmitData}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72603b42","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Employee/EditEmployee.vue
// module id = null
// module chunks = 